module.exports = __webpack_public_path__ + "media/images/url-2cb3e814597dba2768cd1133c2ae830f.png";